export { default as process } from 'process';